module.exports = __webpack_public_path__ + "media/11.2b15367f.mp3";